import { ShadowSettingKey, UneditableShapeSettings } from '@lessonup/pins-shared';
import { styled } from '@lessonup/ui-components';
import React from 'react';
import { computeShadowFilter } from '../../utils/effects/shadow/shadow';

/**
 * This is a copy of the shapes renderer that we had before the Shapes MVP.
 * We can't get rid of it yet because the uneditable shapes from the SDI conversion also uses this.
 * ToDo: Clean up as part of ED-1454
 * */
interface UneditableShapePinComponentProps {
  settings: UneditableShapeSettings;
  width: number;
  height: number;
}

const trianglePoints = (width: number, height: number) => `0,${height} ${width / 2},0 ${width},${height}`;

enum PolygonShapes {
  ELLIPSE = 'ELLIPSE',
  TRIANGLE = 'TRIANGLE',
}

export const UneditableShapePinComponent = (props: UneditableShapePinComponentProps) => {
  const { settings, width, height } = props;

  const getPolygonShape = (shapeType: UneditableShapeSettings['shapeType']) => {
    switch (shapeType) {
      case 'TRIANGLE':
        return PolygonShapes.TRIANGLE;
      case 'ELLIPSE':
      default:
        return PolygonShapes.ELLIPSE;
    }
  };

  const renderShape = (shape: PolygonShapes, settings: UneditableShapeSettings) => {
    switch (shape) {
      case PolygonShapes.ELLIPSE:
        return (
          <ellipse
            cx={width / 2}
            cy={height / 2}
            rx={width / 2}
            ry={height / 2}
            fill={settings.fillColor ?? 'transparent'}
            stroke={settings.strokeColor}
            strokeWidth={settings.strokeThickness ?? 1}
          />
        );
      case PolygonShapes.TRIANGLE:
        return (
          <polygon
            points={trianglePoints(width, height)}
            fill={settings.fillColor ?? 'transparent'}
            stroke={settings.strokeColor}
            strokeWidth={settings.strokeThickness ?? 1}
          />
        );
    }
  };

  return (
    <StyledSvg shadow={settings.shadow} width={width} height={height}>
      {renderShape(getPolygonShape(settings.shapeType), settings)}
    </StyledSvg>
  );
};

const StyledSvg = styled.svg<{ shadow?: ShadowSettingKey }>`
  position: absolute;
  overflow: visible;
  ${(props) => props.shadow && `filter: drop-shadow(${computeShadowFilter(props.shadow)});`}
`;
